/**
 * @type {StoreDescriptor}
 */
export default {
  name: 'requests',
  keyPath: ['url', 'method', 'hash'],
  indexes: [['date', 'date']],
}
